export const TEMPLATE_OPTIONS = {
  chart: {
    type: 'line',
    marginLeft: 130, // Adjust the left margin value as needed
    spacingLeft: 0,
    marginBottom: 10,
  },
  tooltip: {
    shared: true, // Show tooltips for all series at the same time
    crosshairs: true, // Show crosshairs for better alignment
  },
  title: {
    text: '',
  },
  legend: {
    enabled: false, // This will hide the legend
  },
  credits: {
    enabled: false,
  },
  exporting: {
    enabled: false, // Disables the exporting menu
  },
  xAxis: {
    className: 'custom-highcharts',
    crosshair: true,
    labels: {
      autoRotation: false,
      style: {
        fontSize: 10,
      },
      enabled: true,
    },
    scrollbar: {
      enabled: true, // Enable scrollbar
    },
    categories: [],
    opposite: true, //
  },
  yAxis: [],

  series: [],
  plotOptions2: {
    series: {
      states: {
        inactive: {
          enabled: false, // Keep all graphs active
        },
      },
    },
  },
}

export const TEMP_OPTIONS = {
  yAxis: [
    {
      minorTickInterval: 'auto',
      crosshair: true,
      title: {
        text: 'Temperature °C',
        style: {
          color: 'blue', // Set the color of the yAxis title to red
        },
      },
      plotLines: [
        {
          value: 38,
          color: 'red',
          width: 2,
          zIndex: 5,
          dashStyle: 'Dash',
          label: {
            text: '°C',
            align: 'right',
            style: {
              color: 'red',
              fontWeight: 'bold',
            },
          },
        },
      ],
      min: 35,
      max: 41,
    },
    {
      minorTickInterval: 'auto',
      title: {
        text: 'HR / RR (ครั้ง/นาที)',
        style: {
          color: '#dc3545', // Set the color of the yAxis title to red
        },
      },
      plotLines: [
        {
          value: 20,
          color: 'red',
          width: 2,
          zIndex: 5,
          dashStyle: 'Dash',
          label: {
            text: 'RR',
            align: 'right',
            style: {
              color: 'red',
              fontWeight: 'bold',
            },
          },
        },
        {
          value: 100,
          color: 'red',
          width: 2,
          zIndex: 5,
          dashStyle: 'Dash',
          label: {
            text: 'HR',
            align: 'right',
            style: {
              color: 'red',
              fontWeight: 'bold',
            },
          },
        },
      ],
      min: 20,
      max: 160,
    },
  ],

  series: [
    {
      yAxis: 0,
      name: 'Temperature',
      color: 'blue',
      data: [],
      tooltip: {
        valueSuffix: ' °C',
      },
      dataLabels: {
        enabled: true,
        format: '{y}', // Display the Y value (the number at each point)
        style: {
          fontWeight: 'bold',
          color: 'black',
          textOutline: 'none',
        },
      },
      zones: [
        {
          value: 38,
          color: '#007bff',
          marker: {
            fillColor: '#007bff',
          },
        },
        {
          color: '#dc3545',
          marker: {
            fillColor: '#dc3545',
          },
        },
      ],
    },
    {
      yAxis: 1,
      name: 'HR',
      color: '#dc3545',
      data: [],
      tooltip: {
        valueSuffix: ' ครั้ง/นาที',
      },
      dataLabels: {
        enabled: true,
        format: '{y}', // Display the Y value (the number at each point)
        style: {
          fontWeight: 'bold',
          color: 'black',
          textOutline: 'none',
        },
      },
      zones: [
        {
          value: 100,
          color: '#dc3545',
          marker: {
            fillColor: '#dc3545',
          },
        },
        {
          color: '#dc3545',
          marker: {
            fillColor: '#dc3545',
          },
        },
      ],
    },
    {
      yAxis: 1,
      name: 'RR',
      color: 'green',
      data: [],
      tooltip: {
        valueSuffix: ' ครั้ง/นาที',
      },
      dataLabels: {
        enabled: true,
        format: '{y}', // Display the Y value (the number at each point)
        style: {
          fontWeight: 'bold',
          color: 'black',
          textOutline: 'none',
        },
      },
      zones: [
        {
          value: 20,
          color: 'green',
          marker: {
            fillColor: 'green',
          },
        },
        {
          color: 'green',
          marker: {
            fillColor: 'green',
          },
        },
      ],
    },
  ],
  plotOptions: {
    series: {
      cursor: 'pointer',
      point: {
        events: {
          click: function () {
            // เปิด modal
            console.log('option', this)
          },
        },
      },
    },
  },
  tooltip: {
    shared: true,
    formatter: function () {
      let s = `<b>Time : ${this.x}</b><br/>`
      //${p.series.tooltipOptions.valueSuffix}
      this.points.forEach((p) => {
        //console.log('p',p)
        //<span style=\"color:{point.color}\">●</span> {series.name}: <b>{point.y}</b><br/>
        //s += `${p.series.name}: ${p.y} ${p.series.tooltipOptions.valueSuffix}`;
        s += `<span style=\"color:${p.point.color}\">●</span> ${p.series.name}: <b>${p.point.y} </b> ${p.series.tooltipOptions.valueSuffix}<br/>`
        if (p.point.commentList && p.point.commentList.length > 0) {
          p.point.commentList.forEach((item) => {
            s += ' 📝 ' + item.comment + ' <br/>'
          })
        }
        s += ''
      })
      return s
    },
  },
}

export const BP_OPTIONS = {
  yAxis: [
    {
      min: 90,
      max: 180,
      minorTickInterval: 'auto',
      title: {
        text: 'Systolic BP (mmHg)',
        style: {
          color: 'orange', // Set the color of the yAxis title to red
        },
      },
      plotLines: [
        {
          value: 140,
          color: '#FF0000',
          width: 2,
          zIndex: 5,
          label: {
            text: 'Systolic',
            align: 'right',
            style: {
              color: 'orange',
            },
          },
        },
      ],
    },
    {
      min: 50,
      max: 120,
      minorTickInterval: 'auto',
      title: {
        text: 'Diastolic BP (mmHg)',
        style: {
          color: 'skyblue', // Set the color of the yAxis title to red
        },
      },
      plotLines: [
        {
          value: 60,
          color: '#FF0000',
          width: 2,
          zIndex: 5,
          label: {
            text: 'Diastolic',
            align: 'right',
            style: {
              color: 'skyblue',
            },
          },
        },
      ],
    },
  ],

  series: [
    {
      yAxis: 0,
      name: 'Systolic BP',
      color: 'orange',
      data: [],
      tooltip: {
        valueSuffix: ' mmHg',
      },
    },
    {
      yAxis: 1,
      name: 'Diastolic BP',
      color: 'skyblue',
      data: [],
      tooltip: {
        valueSuffix: ' mmHg',
      },
    },
  ],
}

export const BP_PR_RANGE_OPTIONS = {
  chart: {
    marginLeft: 130, // Adjust the left margin value as needed
    spacingLeft: 0,
  },
  yAxis: [
    {
      min: 60,
      max: 170,
      title: {
        text: 'BP/HR',
        style: {
          color: 'lightblue', // Set the color of the yAxis title to red
        },
      },
      plotLines: [
        {
          value: 140,
          color: '#FF0000',
          width: 20,
          zIndex: 5,
          label: {
            align: 'right',
            style: {
              color: 'orange',
            },
          },
        },
        {
          value: 60,
          color: 'red',
          width: 2,
          zIndex: 5,
          label: {
            align: 'right',
            style: {
              color: 'orange',
            },
          },
        },
      ],
    },
  ],
  plotOptions: {
    columnrange: {
      // borderRadius: '30%',
      dataLabels: {
        enabled: true,
        format: '{y}',
      },
    },
  },

  series: [
    {
      yAxis: 0,
      type: 'columnrange',
      name: 'BP',
      color: 'lightblue',
      data: [],
      tooltip: {
        valueSuffix: ' mmHg',
      },
    },
    {
      name: 'HR',
      type: 'line', // Line chart for average values
      data: [], // Average BP values for each patient
      marker: {
        enabled: true,
        radius: 4,
      },
      lineWidth: 2,
      color: '#dc3545',
      tooltip: {
        valueSuffix: ' ครั้ง/นาที',
      },
      dataLabels: {
        enabled: true,
        format: '{y}', // Display the Y value (the number at each point)
        style: {
          fontWeight: 'bold',
          color: 'black',
          textOutline: 'none',
        },
      },
    },
  ],
}

export const PAIN_OPTIONS = {
  yAxis: [
    {
      min: 1,
      max: 10,
      minorTickInterval: 'auto',
      title: {
        text: 'Pain Scale (1-10)',
        style: {
          color: 'pink', // Set the color of the yAxis title to red
        },
      },
    },
  ],

  series: [
    {
      yAxis: 0,
      name: 'Pain Scale',
      color: 'pink',
      data: [],
      dataLabels: {
        enabled: true,
        format: '{y}', // Display the Y value (the number at each point)
        style: {
          fontWeight: 'bold',
          color: 'black',
          textOutline: 'none',
        },
      },
    },
  ],
}

export const OTHER_OPTIONS = {
  yAxis: [
    {
      min: 1,
      max: 100,
      minorTickInterval: 'auto',
      title: {
        text: 'Other',
        style: {
          color: 'grey', // Set the color of the yAxis title to red
        },
      },
    },
  ],

  series: [
    {
      yAxis: 0,
      name: 'Other',
      color: 'grey',
      data: [],
    },
  ],
}

export const BP_HM_OPTIONS = {
  chart: {
    type: 'heatmap',
    marginTop: 0,
    marginBottom: 0,
    plotBorderWidth: 1,
    marginLeft: 130,
    height: '40px',
  },

  title: {
    text: undefined,
    style: {
      fontSize: '1em',
    },
  },

  xAxis: {
    categories: [
      // '02', '06', '10', '14', '18','22',
      // '02', '06', '10', '14', '18','22',
      // '02', '06', '10', '14', '18','22',
      // '02', '06', '10', '14', '18','22',
      // '02', '06', '10', '14', '18','22',
      // '02', '06', '10', '14', '18','22',
      // '02', '06', '10', '14', '18','22',
    ],
  },

  yAxis: {
    categories: [], //['Respiration Rate', 'Systolic', 'Diastolic', 'O2 Sat'],
    title: null,
    reversed: true,
  },

  accessibility: {
    point: {
      descriptionFormat:
        '{(add index 1)}. ' +
        '{series.xAxis.categories.(x)} sales ' +
        '{series.yAxis.categories.(y)}, {value}.',
    },
  },

  colorAxis: {
    minColor: '#ffffff',
    maxColor: '#ffffff',
    nullColor: '#FFFFFF',
  },

  legend: {
    align: 'bottom',
    layout: 'vertical',
    margin: 0,
    verticalAlign: 'top',
    y: 25,
    symbolHeight: 280,
    enabled: false,
  },

  tooltip: {
    enabled: false,
    format:
      '<b>{series.xAxis.categories.(point.x)}</b> sold<br>' +
      '<b>{point.value}</b> items on <br>' +
      '<b>{series.yAxis.categories.(point.y)}</b>',
  },

  series: [
    {
      name: 'V/S Record',
      data: [
        //  [0, 0, 10], [0, 1, 19], [0, 2, 8], [0, 3, 24],
        //  [1, 0, 92], [1, 1, 58], [1, 2, 78], [1, 3, 117],
        // [2, 0, 35], [2, 1, 15], [2, 2, 123], [2, 3, 64],
        // [3, 0, 72], [3, 1, 132], [3, 2, 114], [3, 3, 19],
        // [4, 0, 38], [4, 1, 5], [4, 2, 8], [4, 3, 117],
        // [5, 0, 88], [5, 1, 32], [5, 2, 0], [5, 3, 0],
        // [6, 0, 13], [6, 1, 44], [6, 2, 88], [6, 3, 98],
        // [7, 0, 31], [7, 1, 1], [7, 2, 82], [7, 3, 32],
        // [8, 0, 85], [8, 1, 97], [8, 2, 123], [8, 3, 64],
        // [9, 0, 47], [9, 1, 114], [9, 2, 31], [9, 3, 48],
        // [10, 0, 47], [10, 1, 114], [10, 2, 31], [10, 3, 0],
        //[11, 0, 47], [11, 1, 114], [11, 2, 31], [11, 3, 48],
      ],
      dataLabels: {
        enabled: true,
        allowOverlap: true,
        crop: false,
        overflow: 'allow',
        style: {
          fontSize: '10px', // Set your desired font size here
          fontWeight: 'normal', // Optional: make it bold
        },
        formatter: function () {
          return this.point.value // Display the string value
        },
      },
      borderWidth: 1,
      color: '#e6e6e6',
    },
  ],
  exporting: {
    enabled: false, // Disables the exporting menu
  },
  plotOptions2: {
    series: {
      dataLabels: {
        formatter: function () {
          if (this.point.value > 0) {
            return this.point.value
          }
        },
      },
    },
  },

  responsive2: {
    rules: [
      {
        condition: {
          maxWidth: 500,
        },
        chartOptions: {
          yAxis: {
            labels: {
              format: '{substr value 0 1}',
            },
          },
        },
      },
    ],
  },
}

export const SYMPTOM_OPTIONS = {
  chart: {
    height: 150, // 👈 จำกัดความสูงที่นี่ (หน่วยเป็น px)
  },
  yAxis: [
    {
      min: 1,
      max: 10,
      minorTickInterval: 'auto',
      title: {
        text: 'Pain (1-10)',
        style: {
          color: 'pink', // Set the color of the yAxis title to red
        },
      },
    },
  ],
  tooltip: {
    enabled: true,
    shared: true,
    headerFormat: '<b></b><br>',
    pointFormat:
      '{series.name}: <span style="color:{point.color}">{point.y}</span><br/>',
  },
  series: [
    {
      yAxis: 0,
      name: 'Pain',
      color: 'pink',
      data: [],
      dataLabels: {
        enabled: true,
        format: '{y}', // Display the Y value (the number at each point)
        style: {
          fontWeight: 'bold',
          color: 'black',
          textOutline: 'none',
        },
      },
    },
  ],
}

// date time
export const TEMP_DATETIME_OPTIONS = {
  chart: {
    zoomType: 'x',
    marginTop: 50,
  },

  xAxis: {
    type: 'datetime',
    tickInterval: 60 * 60 * 1000,
    minTickInterval: 15 * 60 * 1000,
    labels: { format: '{value:%H:%M}' },
    opposite: true,
  },

  yAxis: [
    // 🌡 Temperature
    {
      minorTickInterval: 'auto',
      crosshair: true,
      title: {
        text: 'Temperature °C',
        style: { color: 'blue' },
      },
      plotLines: [
        {
          value: 38,
          color: 'red',
          width: 2,
          zIndex: 5,
          dashStyle: 'Dash',
          label: {
            text: '°C',
            align: 'right',
            style: { color: 'red', fontWeight: 'bold' },
          },
        },
      ],
      min: 35,
      max: 41,
    },

    // HR / RR
    {
      minorTickInterval: 'auto',
      title: {
        text: 'HR / RR (ครั้ง/นาที)',
        style: { color: '#dc3545' },
      },
      plotLines: [
        {
          value: 20,
          color: 'red',
          width: 2,
          dashStyle: 'Dash',
          label: { text: 'RR', align: 'right' },
        },
        {
          value: 100,
          color: 'red',
          width: 2,
          dashStyle: 'Dash',
          label: { text: 'HR', align: 'right' },
        },
      ],
      min: 20,
      max: 160,
      opposite: false,
    },
  ],

  series: [
    {
      yAxis: 0,
      name: 'Temperature',
      color: 'blue',
      data: [], // [timestamp, value]
      tooltip: { valueSuffix: ' °C' },
      dataLabels: {
        enabled: true,
        format: '{y}',
        style: {
          fontWeight: 'bold',
          color: 'black',
          textOutline: 'none',
        },
      },
      zones: [{ value: 38, color: '#007bff' }, { color: '#dc3545' }],
    },

    {
      yAxis: 1,
      name: 'HR',
      color: '#dc3545',
      data: [],
      tooltip: { valueSuffix: ' ครั้ง/นาที' },
      dataLabels: {
        enabled: true,
        format: '{y}',
        style: {
          fontWeight: 'bold',
          color: 'black',
          textOutline: 'none',
        },
      },
      zones: [{ value: 100, color: '#dc3545' }, { color: '#dc3545' }],
    },

    {
      yAxis: 1,
      name: 'RR',
      color: 'green',
      data: [],
      tooltip: { valueSuffix: ' ครั้ง/นาที' },
      dataLabels: {
        enabled: true,
        format: '{y}',
        style: {
          fontWeight: 'bold',
          color: 'black',
          textOutline: 'none',
        },
      },
      marker: { symbol: 'square' },
      zones: [{ value: 20, color: 'green' }, { color: 'green' }],
    },
  ],

  plotOptions: {
    series: {
      cursor: 'pointer',
      connectNulls: true,
      point: {
        events: {
          click() {
            console.log('point', this)
          },
        },
      },
    },
  },

  tooltip: {
    shared: true,
    formatter() {
      const time = new Date(this.x).toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
      })

      let s = `<b>Time : ${time}</b><br/>`

      this.points?.forEach((p) => {
        s += `<span style="color:${p.color}">●</span>
              ${p.series.name}: <b>${p.y}</b> ${p.series.tooltipOptions.valueSuffix}<br/>`
      })

      return s
    },
  },
}

export const BP_HM_DT_OPTIONS = {
  chart: {
    type: 'heatmap',
    marginTop: 0,
    marginBottom: 0,
    plotBorderWidth: 1,
    marginLeft: 130,
    height: '40px',
    plotBorderWidth: 1,
    plotBorderColor: '#e6e6e6',
    styledMode: false,
  },

  title: { text: undefined },

  xAxis: {
    type: 'datetime',

    tickInterval: 15 * 60 * 1000, // 15 minutes
    labels: {
      format: '{value:%H:%M}',
    },

    minPadding: 0,
    maxPadding: 0,
    gridLineWidth: 1,
    gridLineColor: '#e6e6e6', // 2. Changes the vertical grid lines
    lineColor: '#e6e6e6', // Changes the bottom axis line
    tickColor: '#e6e6e6',
  },

  yAxis: {
    categories: [], //['Respiration Rate', 'Systolic', 'Diastolic', 'O2 Sat'],
    title: null,
    reversed: true,
    gridLineWidth: 1,
    gridLineColor: '#e6e6e6',
    lineColor: '#e6e6e6',
  },

  colorAxis: {
    min: 0,
    max: 1,
    stops: [
      [0, '#ffffff'],
      [1, '#ffffff'],
    ],
    nullColor: '#ffffff',
  },

  legend: { enabled: false },
  plotOptions: {
    heatmap: {
      borderColor: '#e6e6e6',
      borderWidth: 1,
      states: {
        hover: {
          enabled: true,
          borderColor: '#e6e6e6', // Prevents blue on hover
          brightness: 0.1, // Slight change so you know you're hovering
        },
        inactive: {
          opacity: 1, // Prevents fading when other elements are focused
        },
      },
    },
  },
  tooltip: {
    enabled: false,
    format:
      '<b>{series.xAxis.categories.(point.x)}</b> sold<br>' +
      '<b>{point.value}</b> items on <br>' +
      '<b>{series.yAxis.categories.(point.y)}</b>',
  },
  series: [
    {
      name: 'V/S Record',

      data: [],
      color: '#ffffff',
      borderWidth: 1,
      borderColor: '#e6e6e6', // 4. Changes the border around each cell
      nullColor: '#ffffff',
      colsize: 15 * 60 * 1000, // EXACT column width
      rowsize: 1,
      dataLabels: {
        enabled: true,
        allowOverlap: true,
        crop: false,
        overflow: 'allow',
        formatter() {
          return this.point.value ?? ''
        },
        style: {
          fontSize: '10px',
          fontWeight: 'normal',
        },
        borderWidth: 1,
        color: '#e6e6e6',
      },
      states: {
        hover: {
          enabled: true,
          borderColor: '#e6e6e6', // Prevents blue outline on mouse hover
          brightness: -0.1,
        },
        inactive: {
          opacity: 1,
        },
      },
    },
  ],

  exporting: { enabled: false },
}

export const BP_PR_RANGE_DT_OPTIONS = {
  chart: {
    marginLeft: 130, // Adjust the left margin value as needed
    spacingLeft: 0,
  },
  xAxis: {
    type: 'datetime',
    title: {
      text: '',
    },
  },
  yAxis: [
    {
      min: 60,
      max: 170,
      title: {
        text: 'BP/HR',
        style: {
          color: 'lightblue', // Set the color of the yAxis title to red
        },
      },
      plotLines: [
        {
          value: 140,
          color: '#FF0000',
          width: 20,
          zIndex: 5,
          label: {
            align: 'right',
            style: {
              color: 'orange',
            },
          },
        },
        {
          value: 60,
          color: 'red',
          width: 2,
          zIndex: 5,
          label: {
            align: 'right',
            style: {
              color: 'orange',
            },
          },
        },
      ],
    },
  ],
  plotOptions: {
    columnrange: {
      // borderRadius: '30%',
      dataLabels: {
        enabled: true,
        format: '{y}',
      },
    },
  },

  series: [
    {
      yAxis: 0,
      type: 'columnrange',
      name: 'BP',
      color: 'lightblue',
      data: [],
      tooltip: {
        valueSuffix: ' mmHg',
      },
    },
    {
      name: 'HR',
      type: 'line', // Line chart for average values
      data: [], // Average BP values for each patient
      marker: {
        enabled: true,
        radius: 4,
      },
      lineWidth: 2,
      color: '#dc3545',
      tooltip: {
        valueSuffix: ' ครั้ง/นาที',
      },
      dataLabels: {
        enabled: true,
        format: '{y}', // Display the Y value (the number at each point)
        style: {
          fontWeight: 'bold',
          color: 'black',
          textOutline: 'none',
        },
      },
    },
  ],
}

export const PAIN_DT_OPTIONS = {
  chart: {
    height: 300,
    marginBottom: 60,
  },
  xAxis: {
    type: 'datetime',
    labels: {
      enabled: true,
      formatter() {
        const d = new Date(this.value)

        const hh = String(d.getHours()).padStart(2, '0')
        const mm = String(d.getMinutes()).padStart(2, '0')

        return `${hh}:${mm}`
      },
    },
  },

  yAxis: [
    {
      min: 1,
      max: 10,
      title: {
        text: 'Pain Scale (1-10)',
        style: { color: 'pink' },
      },
    },
  ],
  tooltip: {
    enabled: false,
  },
  series: [
    {
      name: 'Pain Scale',
      color: 'pink',
      data: [],
      dataLabels: {
        enabled: true,
        format: '{y}',
        style: {
          fontWeight: 'bold',
          color: 'black',
          textOutline: 'none',
        },
      },
    },
  ],
}
